import { Command } from 'cmdk';

import { CustomerGroupMessage } from '../../../../../types/CustomerGroupMessage';
import { Text } from '../../../../cdl/Text/Text';
import { useCustomerList } from '../../../../group/customer/detail/hooks/useCustomerList';
import { formatCompanyName } from '../../../helpers/formatCompanyName.helper';
import { IconCornerDownRight } from '../../../icons/cdl/CornerDownRight';
import { GroupContextType } from '../../../utils/groupContextType';
import { useGroupContextSelectionHandler } from '../../hooks/useGroupContextSelectionHandler';
import { CommandItem } from '../CommandItem';

interface GroupDetailProps {
    customerGroup: CustomerGroupMessage;
}

export const GroupContextCustomerGroupDetail = (props: GroupDetailProps) => {
    const customersQuery = useCustomerList({ groupId: props.customerGroup.id });
    const { selectGroup, selectCompany } = useGroupContextSelectionHandler();

    return (
        <Command.Group style={{ minWidth: 0 }}>
            <CommandItem
                value={`group-${props.customerGroup.id}`}
                onSelect={() => {
                    void selectGroup({ groupId: props.customerGroup.id, type: GroupContextType.CUSTOMER_GROUP });
                }}
            >
                <Text fontWeight="bold">{props.customerGroup.name}</Text>
            </CommandItem>
            {customersQuery.data?.map((customer) => (
                <CommandItem
                    key={customer.id}
                    value={`group-${props.customerGroup.id}-${customer.id}`}
                    Icon={IconCornerDownRight}
                    onSelect={() => {
                        void selectCompany({
                            companyId: customer.id,
                            groupId: customer.customerGroupId,
                            type: GroupContextType.CUSTOMER_COMPANY,
                        });
                    }}
                >
                    {formatCompanyName({ company: customer })}
                </CommandItem>
            ))}
            <Command.Separator alwaysRender />
        </Command.Group>
    );
};
